import React from 'react'
import { Link } from 'react-router-dom';
import styles from '../components/componentsStyles/Footer.module.css';
import {BsInstagram, BsGithub} from 'react-icons/bs'

const Footer = () => {
  return (
    <div className={styles.footer}>
        <div className={styles.left}>
            <Link to="/about"> About me</Link>  
            <p> Contact: mtsgosk8@gmail.com</p>  
        </div>
        <div className={styles.center}>
            <p> By @MTSTech, all rights reserved, 2024</p>
        </div>
        <div className={styles.social}>
            <a href='/'><BsInstagram/> Instagran</a>
            <a href='/'><BsGithub/> GitHub  </a>
        </div>

    </div>
  )
}

export default Footer